<div class="payer-invitations">
  <h2>Registro de pagadores</h2>
  <p class="subtitle">
    Comparte tu enlace con las personas que te van a pagar. Cada una se registra
    con sus propios datos y queda en revisión antes de que sus pagos se acrediten
    a tu saldo.
  </p>

  <!-- Link permanente del cliente -->
  <mat-card class="link-card" *ngIf="miLink">
    <div class="link-head">
      <h3>Tu enlace de registro</h3>
      <span class="estado" [class.estado-activo]="miLink.activo" [class.estado-pausado]="!miLink.activo">
        {{ miLink.activo ? 'Activo' : 'Pausado' }}
      </span>
    </div>

    <ng-container *ngIf="miLink.url; else sinLink">
      <div class="link-url" [class.inactivo]="!miLink.activo">
        <code>{{ miLink.url }}</code>
      </div>
      <p class="motivo" *ngIf="!miLink.activo">{{ motivoLink }}</p>
      <div class="link-actions">
        <button mat-raised-button color="primary" type="button" (click)="copiar(miLink.url)" [disabled]="!miLink.activo">
          <mat-icon>content_copy</mat-icon> Copiar enlace
        </button>
        <button mat-stroked-button type="button" class="wa" (click)="compartirWhatsapp(miLink.url)" [disabled]="!miLink.activo">
          <mat-icon>share</mat-icon> Compartir por WhatsApp
        </button>
        <button mat-button type="button" color="warn" (click)="regenerarLink()" [disabled]="miLink.motivo === 'CUENTA_NO_HABILITADA'">
          <mat-icon>autorenew</mat-icon> Regenerar
        </button>
      </div>
      <p class="hint">En revisión ahora: {{ miLink.pendientes }} de {{ miLink.pendientesMax }}.</p>
    </ng-container>
    <ng-template #sinLink>
      <p class="motivo">{{ motivoLink || 'Tu cuenta todavía no tiene un enlace de registro.' }}</p>
    </ng-template>

    <!-- Reglas: qué pasa con cada registro -->
    <div class="reglas">
      <button mat-button type="button" class="reglas-toggle" (click)="verReglas = !verReglas">
        <mat-icon>{{ verReglas ? 'expand_less' : 'expand_more' }}</mat-icon>
        Cómo funciona y reglas del enlace
      </button>
      <div *ngIf="verReglas">
        <h4>Qué hace la persona que abre tu enlace</h4>
        <ol>
          <li>Elige su país (Chile o Venezuela) y escribe su documento, su email y su WhatsApp.</li>
          <li>Confirma su WhatsApp y su email con un código que le enviamos a cada uno.</li>
          <li>Saca una foto de su cédula. El documento de la foto tiene que coincidir con el que escribió.</li>
          <li>Se toma una selfie con la cámara en ese momento. No sirven fotos guardadas, de una pantalla ni impresas.</li>
          <li>Completa sus datos de residencia y profesión, y envía.</li>
        </ol>

        <h4>Quién puede registrarse</h4>
        <ul>
          <li>Solo personas, no empresas.</li>
          <li>Mayores de 18 años, con su cédula vigente.</li>
          <li>No puede ser cliente de Aguacate ni estar registrado como pagador de otra cuenta.</li>
          <li>Cada persona usa su propio WhatsApp y su propio email: un mismo número o email sirve para {{ miLink.reglas.documentosPorContacto }} personas como máximo.</li>
        </ul>

        <h4>Qué pasa después</h4>
        <ul>
          <li>Cada registro queda <b>en revisión</b>. Mientras no lo aprobemos, las transferencias de esa persona no se acreditan a tu saldo: quedan retenidas hasta la aprobación.</li>
          <li>Si tienes {{ miLink.pendientesMax }} pagadores en revisión al mismo tiempo, el enlace se pausa solo y se reactiva cuando terminemos de revisarlos.</li>
          <li>Ves cada registro en las pestañas de abajo: "Registro en curso" mientras la persona lo completa, "En revisión" cuando ya lo envió y "Activos" cuando está aprobado.</li>
        </ul>

        <h4>Límites para evitar abusos</h4>
        <ul>
          <li>Hasta {{ miLink.reglas.registrosPorDia }} intentos por día con un mismo documento, email o WhatsApp.</li>
          <li>Hasta {{ miLink.reglas.otpPorDia }} códigos por día a un mismo WhatsApp o email.</li>
          <li>Si alguien llega a un límite, la página le dice desde qué hora puede volver a intentarlo.</li>
        </ul>

        <h4>Tu enlace</h4>
        <ul>
          <li>No vence. Funciona mientras tu cuenta esté aprobada y habilitada para recibir pagadores.</li>
          <li>Si lo compartiste con alguien que no corresponde, usa "Regenerar": el anterior deja de funcionar al instante.</li>
          <li>Nunca te pediremos que compartas los códigos que recibe tu pagador.</li>
        </ul>
      </div>
    </div>
  </mat-card>

  <!-- Formulario de invitación por pagador: reemplazado por el link permanente
       (12/10/2026). Se oculta, no se borra, por si se reactiva. -->
  <mat-card class="form-card" *ngIf="false">
    <form [formGroup]="form" (ngSubmit)="crear()">
      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>País</mat-label>
          <input matInput [value]="paisLabel" disabled />
          <mat-hint>Definido por tu tipo de cuenta</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="tipoUsuarioId">
            <mat-option [value]="0">Persona</mat-option>
            <mat-option [value]="1">Empresa</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>{{ pais === 'VE' ? 'Cédula del pagador' : 'RUT del pagador' }}</mat-label>
          <input matInput formControlName="rut"
            [maxlength]="docMaxLength"
            [placeholder]="docPlaceholder" />
          <mat-hint align="end">Máx. {{ docMaxLength }}</mat-hint>
          <mat-error *ngIf="form.get('rut')?.hasError('maxlength')">
            Máximo {{ docMaxLength }} caracteres
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Email del pagador</mat-label>
          <input matInput type="email" formControlName="contactEmail"
            [maxlength]="emailMaxLength" />
          <mat-error *ngIf="form.get('contactEmail')?.hasError('email')">
            Email inválido
          </mat-error>
          <mat-error *ngIf="form.get('contactEmail')?.hasError('maxlength')">
            Máximo {{ emailMaxLength }} caracteres
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Teléfono del pagador (con prefijo)</mat-label>
          <input matInput formControlName="contactPhone"
            [maxlength]="phoneMaxLength"
            [placeholder]="phonePlaceholder" />
          <mat-hint align="end">Máx. {{ phoneMaxLength }}</mat-hint>
          <mat-error *ngIf="form.get('contactPhone')?.hasError('maxlength')">
            Máximo {{ phoneMaxLength }} caracteres
          </mat-error>
        </mat-form-field>
      </div>

      <p class="hint">RUT, email y teléfono son obligatorios.</p>

      <button mat-raised-button color="primary" type="submit">
        Validar y generar enlace
      </button>
    </form>
  </mat-card>

  <mat-card class="table-card">
    <div class="loading" *ngIf="loading">
      <mat-spinner diameter="36"></mat-spinner>
    </div>

    <mat-tab-group animationDuration="0ms">
      <!-- ACTIVOS: pagadores habilitados -->
      <mat-tab label="Activos ({{ dsActivos.data.length }})">
        <ng-template matTabContent>
          <table mat-table [dataSource]="dsActivos" class="mat-elevation-z1">
            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef>Pagador</th>
              <td mat-cell *matCellDef="let p">{{ nombrePagador(p) }}</td>
            </ng-container>
            <ng-container matColumnDef="documento">
              <th mat-header-cell *matHeaderCellDef>Documento</th>
              <td mat-cell *matCellDef="let p">{{ documentoPagador(p) }}</td>
            </ng-container>
            <ng-container matColumnDef="tipo">
              <th mat-header-cell *matHeaderCellDef>Tipo</th>
              <td mat-cell *matCellDef="let p">{{ tipoLabel(p.tipoUsuarioId == 1 ? 1 : 0) }}</td>
            </ng-container>
            <ng-container matColumnDef="fecha">
              <th mat-header-cell *matHeaderCellDef>Registro</th>
              <td mat-cell *matCellDef="let p">{{ p.created_at | date: 'short' }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="colsActivos"></tr>
            <tr mat-row *matRowDef="let row; columns: colsActivos"></tr>
          </table>
          <mat-paginator #pagActivos [pageSize]="10" [pageSizeOptions]="[10, 25, 50]"
            [hidden]="!dsActivos.data.length"></mat-paginator>
          <p class="empty" *ngIf="!loading && !dsActivos.data.length">
            Aún no tienes pagadores activos.
          </p>
          <div class="ver-todos" *ngIf="dsActivos.data.length">
            <button mat-button color="primary" (click)="verPagador()">Ver detalle en Mis pagadores</button>
          </div>
        </ng-template>
      </mat-tab>

      <!-- PENDIENTES: links sin completar + pagadores en revisión -->
      <mat-tab label="Pendientes ({{ dsPendientes.data.length }})">
        <ng-template matTabContent>
          <table mat-table [dataSource]="dsPendientes" class="mat-elevation-z1">
            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef>Pagador</th>
              <td mat-cell *matCellDef="let f">
                {{ f.nombre }}
                <div class="sub" *ngIf="f.inv">
                  {{ f.inv.contactEmail || f.inv.contactPhone || '' }}
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="documento">
              <th mat-header-cell *matHeaderCellDef>Documento</th>
              <td mat-cell *matCellDef="let f">{{ f.documento }}</td>
            </ng-container>
            <ng-container matColumnDef="tipo">
              <th mat-header-cell *matHeaderCellDef>Tipo</th>
              <td mat-cell *matCellDef="let f">{{ tipoLabel(f.tipoUsuarioId) }}</td>
            </ng-container>
            <ng-container matColumnDef="estado">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let f">
                <span class="estado estado-pendiente">{{ f.estado }}</span>
                <div class="sub" *ngIf="f.inv && !f.inv.linkPermanente">Vence {{ f.inv.expiresAt | date: 'short' }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="fecha">
              <th mat-header-cell *matHeaderCellDef>Fecha</th>
              <td mat-cell *matCellDef="let f">{{ f.fecha | date: 'short' }}</td>
            </ng-container>
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let f">
                <ng-container *ngIf="f.inv as inv">
                  <button mat-icon-button color="primary" *ngIf="inv.url" title="Copiar link"
                    (click)="copiar(inv.url)">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                  <button mat-icon-button color="primary" title="Reenviar / nuevo link"
                    *ngIf="!inv.linkPermanente" (click)="reenviar(inv)">
                    <mat-icon>refresh</mat-icon>
                  </button>
                  <button mat-icon-button color="warn" title="Revocar" (click)="revocar(inv)">
                    <mat-icon>block</mat-icon>
                  </button>
                </ng-container>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="colsPendientes"></tr>
            <tr mat-row *matRowDef="let row; columns: colsPendientes"></tr>
          </table>
          <mat-paginator #pagPendientes [pageSize]="10" [pageSizeOptions]="[10, 25, 50]"
            [hidden]="!dsPendientes.data.length"></mat-paginator>
          <p class="empty" *ngIf="!loading && !dsPendientes.data.length">
            No tienes pagadores pendientes.
          </p>
        </ng-template>
      </mat-tab>

      <!-- RECHAZADOS: verificación fallida, vencidos o revocados -->
      <mat-tab label="Rechazados ({{ dsRechazados.data.length }})">
        <ng-template matTabContent>
          <table mat-table [dataSource]="dsRechazados" class="mat-elevation-z1">
            <ng-container matColumnDef="documento">
              <th mat-header-cell *matHeaderCellDef>Documento</th>
              <td mat-cell *matCellDef="let inv">{{ texto(inv.numeroId) }}</td>
            </ng-container>
            <ng-container matColumnDef="tipo">
              <th mat-header-cell *matHeaderCellDef>Tipo</th>
              <td mat-cell *matCellDef="let inv">{{ tipoLabel(inv.tipoUsuarioId) }}</td>
            </ng-container>
            <ng-container matColumnDef="estado">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let inv">
                <span class="estado estado-{{ inv.status }}">{{ estadoRechazado(inv) }}</span>
                <div class="motivo" *ngIf="inv.status === 'REJECTED' && inv.rejectionReason">
                  {{ inv.rejectionReason }}
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="contacto">
              <th mat-header-cell *matHeaderCellDef>Contacto</th>
              <td mat-cell *matCellDef="let inv">
                <div>{{ inv.contactEmail || '—' }}</div>
                <div>{{ inv.contactPhone || '—' }}</div>
              </td>
            </ng-container>
            <ng-container matColumnDef="fecha">
              <th mat-header-cell *matHeaderCellDef>Fecha</th>
              <td mat-cell *matCellDef="let inv">{{ inv.createdAt | date: 'short' }}</td>
            </ng-container>
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let inv">
                <button mat-icon-button color="primary" title="Generar nuevo link"
                  *ngIf="!inv.linkPermanente" (click)="reenviar(inv)">
                  <mat-icon>refresh</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="colsRechazados"></tr>
            <tr mat-row *matRowDef="let row; columns: colsRechazados"></tr>
          </table>
          <mat-paginator #pagRechazados [pageSize]="10" [pageSizeOptions]="[10, 25, 50]"
            [hidden]="!dsRechazados.data.length"></mat-paginator>
          <p class="empty" *ngIf="!loading && !dsRechazados.data.length">
            No tienes registros rechazados.
          </p>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </mat-card>
</div>
